export enum QuoteRequestPageSteps {
  Routing = "routing",
  Shipment = "shipment",
  Partners = "partners",
  Team = "team",
  Review = "review",
  Confirmation = "confirmation",
}
